import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Login.css';
import Button from '../Components/Common/Button';
import api from '../api/axios';
import { useTheme } from '../ThemeContext';

const Login = () => {
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const { theme } = useTheme();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    if (!username || !password) {
      setError('Please enter both email and password');
      setLoading(false);
      return;
    }

    try {
      const response = await api.post('/login', {
        email: username.trim(),
        password: password.trim()
      });

      const token = response.data.accessToken;
      const user = response.data.user;

      // Log the user object to check if workspace_id and workspace_name are available
      console.log(user);

      if (token) {
        localStorage.setItem('token', token);
        localStorage.setItem('userId', user.id);
        localStorage.setItem('commonId', user.common_id);
        localStorage.setItem('role_id', user.role_id || "");
        const fullUser = {
  id: user.id,
  name: user.name || "",
  email: user.email || "",
  provider: user.provider || "local",
  profile_image: user.profile_image || "",
  hasWorkspace: user.has_workspace || false,
};

        localStorage.setItem("user", JSON.stringify(fullUser));
        localStorage.setItem("profile_image", fullUser.profile_image);
        localStorage.setItem("profile_image", user.profile_image || "");
        
        // ✅ 1. Check for Invited Employee (Has a role but no individual workspace)
       // REPLACE WITH (explicit for all cases)
if (user.has_workspace) {
  navigate("/new-home", { replace: true });
} else {
  navigate("/workspace", { replace: true });
}

        // ✅ 2. Check for Admin/Owner (Standard Logic)
        if (user.has_workspace !== undefined) {
          if (user.has_workspace) {
            navigate("/new-home", { replace: true });
          } else {
            // New organic signup that needs to create the first workspace
            navigate("/workspace", { replace: true });
          }
        } else {
          // Fallback: Check via API if property is missing
          try {
            const wsCheck = await api.get("/workspaces/check");
            if (wsCheck.data.hasWorkspace) {
              navigate("/new-home", { replace: true });
            } else {
              navigate("/workspace", { replace: true });
            }
          } catch (err) {
            console.error("Workspace check failed:", err);
            navigate("/workspace", { replace: true });
          }
        }
      }
    } catch (error) {
      const errorMsg = error.response?.data?.message || "Login failed. Please try again.";
      setError(errorMsg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper d-flex justify-content-center">
      <div className="login-card" style={{ 
        backgroundColor: '#F5F5F5',   // Match the wrapper background
        color: 'var(--text-main)',
        borderColor: 'var(--border-color)'
      }}>
        <div className="logo-section text-center mt-1">
          <img src="/images/kinenew.svg" alt="KINEXAR" className="title-img" style={{ filter: theme === 'dark' ? 'brightness(0) invert(1)' : 'none' }} />
        </div>
        <h2 className="login-header fs-5 mt-5">Login</h2>
        <form onSubmit={handleSubmit}>
          {error && <div className="alert alert-danger">{error}</div>}
          <div className="mb-3 text-start">
            <label className="login-label">Email </label>
            <input 
              type="email" 
              className="form-control custom-input" 
              placeholder="Enter Email" 
              value={username} 
              onChange={(e) => setUsername(e.target.value)} 
              required 
              disabled={loading} 
            />
          </div>
          <div className="mb-1 text-start password-container">
            <label className="login-label">Password</label>
            <input 
              type={showPassword ? "text" : "password"} 
              className="form-control custom-input" 
              placeholder="Enter Password" 
              value={password} 
              onChange={(e) => setPassword(e.target.value)} 
              required 
              minLength="6" 
              disabled={loading} 
            />
            <div 
              className="password-toggle-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
               <i
                className={`bi ${
                  showPassword ? "bi-eye-fill" : "bi-eye-slash-fill"
                } text-secondary`}
              ></i>
            </div>
          </div>
          <div className="mb-4 text-start">
            <span
              className="forgot-password"
              onClick={() => navigate("/forgot-password")}
              style={{ cursor: "pointer" }}
            >
              Forgot password?
            </span>
          </div>
          <Button type="submit" className="w-100" disabled={loading}>
            {loading ? "Logging in..." : "Login"}
          </Button>
        </form>
        <div className="divider-container my-4">
          <span className="divider-text">Or Sign in with</span>
        </div>
        <div className="social-icons d-flex justify-content-center gap-4 mb-4">
          <a href="http://45.118.160.29:4001/api/auth/google">
            <img src="/images/Google.svg" alt="Google" className="social-icon" style={{ cursor: 'pointer' }} />
          </a>
          <img src="/images/Apple.svg" alt="Apple" className="social-icon" />
          
          {/* ✅ THE FIX: Wrapped Microsoft logo in a clickable link pointing to the backend route */}
          <a href="http://localhost:4000/api/auth/microsoft">
  <img src="/images/Microsoft.svg" alt="Microsoft" className="social-icon" style={{ cursor: 'pointer' }} />
</a>
          
        </div>
        <p className="signup-text text-center">
          Don't have an account?
          <span className="sign-up-link text-decoration-none ms-1" onClick={() => navigate('/signup')} style={{ cursor: 'pointer' }}>
            Sign up
          </span>
        </p>
        <div className="monospear-footer">
          <img src="/images/monomain.svg" alt="Monospear" className="monomain-img" />
          <img src="/images/monospear.svg" alt="Monospear Technologies LLC" className="monosubtext-img" />
        </div>
      </div>
    </div>
  );
};

export default Login;